import './ccf-customer-card-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';


/* eslint-disable-next-line */
export interface CcfCustomerCardIconProps extends SvgIconProps {}
/**
 * CcfCustomerCardIcon used to disply customer card icon in the app space panel
 * @param props - CcfCustomerCardIconProps
 * @example -- <CcfCustomerCardIcon />
 */
export function CcfCustomerCardIcon(props: CcfCustomerCardIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 32 22">
      <g id="ic_Customer_Card" data-name="ic_Customer Card" clipPath="url(#clip-ic_Customer_Card)">
        <g id="ic_app_ContactCard" transform="translate(0.41)">
          <g id="Group_111334" data-name="Group 111334" transform="translate(17.531)">
            <rect id="Rectangle_37563" data-name="Rectangle 37563" width="9.149" height="9.149" rx="2" />
            <rect id="Rectangle_37564" data-name="Rectangle 37564" width="13.65" height="3.05" rx="1.525" transform="translate(0 11.69)"/>
            <rect id="Rectangle_37565" data-name="Rectangle 37565" width="13.65" height="3.05" rx="1.525" transform="translate(0 17.28)" />
          </g>
          <g id="Group_111333" data-name="Group 111333" transform="translate(0 0.652)">
            <rect id="Rectangle_37562" data-name="Rectangle 37562" width="9.836" height="9.839" rx="4.918" transform="translate(3.106)"/>
            <path id="Path_13868" data-name="Path 13868" d="M7.326-.439a7.756,7.756,0,0,1,7.765,7.768c0,4.3-15.531,4.3-15.531,0A7.756,7.756,0,0,1,7.326-.439Z" transform="translate(0.439 10.797)" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfCustomerCardIcon;
